// include 4 EdgeConfigurators

import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  EdgeType,
  VariableLocationEdges,
} from "../../../../docuclipper/DocuclipperTypes";
import { ReduxState } from "../../../../redux";
import { setSelectedEdge } from "../../../../redux/reducers/TemplateField";
import { capitalize } from "../../../../utils/utils";
import VariableFieldEdge from "./VariableFieldEdge";
type Props = {
  variableLocationEdges: VariableLocationEdges;
  onSetPercentage: (edgeType: EdgeType) => any;
  onSetWords: (edgeType: EdgeType) => any;

  onWordsChanged: (edgeType: EdgeType, words: string[]) => any;
  enablePercentage: (edgeType: EdgeType) => any;
  disablePercentage: (edgeType: EdgeType) => any;
  updateIncludeWords: (edgeType: EdgeType, checked: boolean) => any;
  onOffsetChange: (edgeType: EdgeType, offset: number) => any;
};

export const VariableField: React.SFC<Props> = ({
  variableLocationEdges,
  onSetPercentage,
  onSetWords,
  onWordsChanged,
  enablePercentage,
  disablePercentage,
  updateIncludeWords,
  onOffsetChange,
}) => {
  const dispatch = useDispatch();
  const { selectedEdge } = useSelector(
    (state: ReduxState) => state.TemplateField
  );

  const onSetPercentageFn = (edgeType: EdgeType) => () => {
    onSetPercentage(edgeType);
  };
  const onSetWordsFn = (edgeType: EdgeType) => () => {
    onSetWords(edgeType);
  };

  const enablePercentageFn = (edgeType: EdgeType) => () => {
    enablePercentage(edgeType);
  };
  const disablePercentageFn = (edgeType: EdgeType) => () => {
    disablePercentage(edgeType);
  };
  const onIncludeWordsCheckedChangeFn = (edgeType: EdgeType) => (
    checked: boolean
  ) => {
    updateIncludeWords(edgeType, checked);
  };
  const onOffsetChangedFn = (edgeType: EdgeType) => (offset: number) => {
    onOffsetChange(edgeType, offset);
  };

  const edges: EdgeType[] = ["top", "bottom", "left", "right"];
  return (
    <>
      <Tabs
        activeKey={selectedEdge || "top"}
        onSelect={(key) =>
          dispatch(setSelectedEdge({ selectedEdge: key as EdgeType }))
        }
        defaultActiveKey="top"
        id="variableLocationEdges"
      >
        {edges.map((edge, i) => (
          <Tab key={i} eventKey={edge} title={`${capitalize(edge)} Edge`}>
            <VariableFieldEdge
              vl={variableLocationEdges}
              onSetPercentage={onSetPercentageFn(edge)}
              onSetWords={onSetWordsFn(edge)}
              onWordsChanged={(words: string[]) => onWordsChanged(edge, words)}
              enablePercentage={enablePercentageFn(edge)}
              disablePercentage={disablePercentageFn(edge)}
              onIncludeWordsCheckedChange={onIncludeWordsCheckedChangeFn(edge)}
              onOffsetChanged={onOffsetChangedFn(edge)}
              edgeType={edge}
            />

            {/* </FieldSection> */}
          </Tab>
        ))}
      </Tabs>
    </>
  );
};
export default VariableField;
